interface IconProps {
  color?: string
}

export const User = ({ color }: IconProps) => {
  return (
    <svg
      aria-hidden="true"
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8.53314C13.9013 8.53314 12.2 10.2345 12.2 12.3331C12.2 14.4318 13.9013 16.1331 16 16.1331C18.0987 16.1331 19.8 14.4318 19.8 12.3331C19.8 11.3253 19.3996 10.3588 18.687 9.64613C17.9744 8.93349 17.0078 8.53314 16 8.53314ZM10.4667 12.3331C10.4667 9.27716 12.944 6.7998 16 6.7998C17.4675 6.7998 18.875 7.38278 19.9127 8.42048C20.9504 9.45818 21.5333 10.8656 21.5333 12.3331C21.5333 15.3891 19.056 17.8665 16 17.8665C12.944 17.8665 10.4667 15.3891 10.4667 12.3331ZM16 21.8665C13.4658 21.8665 10.7327 22.9681 8.59134 24.9667C8.24142 25.2933 7.69301 25.2744 7.36642 24.9245C7.03983 24.5746 7.05874 24.0261 7.40866 23.6996C9.83871 21.4315 12.9845 20.1331 16 20.1331C19.0155 20.1331 22.1613 21.4315 24.5913 23.6996C24.9413 24.0261 24.9602 24.5746 24.6336 24.9245C24.307 25.2744 23.7586 25.2933 23.4087 24.9667C21.2673 22.9681 18.5342 21.8665 16 21.8665Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
